import { useState } from "react"
import InputFormValue from "../../ui/components/InputFormValue"
import axios from "axios"
import { BACKEND } from "../../../config/configEnvs"
import { toast } from "react-toastify"
import DinamicBoxButton from "../../ui/components/DinamicBoxButton"
import { FaSave, FaVoicemail } from "react-icons/fa"
import NoDataScreen from "../../ui/temp-screens/NoDataScreen"

const ClientData = ({client}) => {

  const gmails = client.gmails || []

  return (
    <div> 
      <span className="text-sm font-bold text-slate-600 mb-2">Gmails para dar accesos en Google Drive</span>
      {gmails && gmails.length > 0 ? (
        gmails.map((g) => (
          <InputFormValue
            value={g.gmail}
            disabled={true}
            icon={<FaVoicemail />}
            placeholder="Gmail"
            type="text"
          />
        ) 
      )) : (
        <div className="flex h-full justify-center items-center">
          <NoDataScreen text="No hay gmails registrados" border />
        </div>
      )}
    </div>
  )
}

export default ClientData